<template>
  <div
    v-if="(jwtAccessValid() && userProfile.checked && isReciever) || isAdmin || isManager || isManagerFB"
    class="container pb-3"
    :class="{ 'pt-1': list }"
    style="max-width: 400px"
  >
    <h1 class="text-center" v-if="!loading">
      <span v-if="!doc.writeOff">
        АКТ ПЕРЕДАЧИ
      </span>
      <span v-if="doc.writeOff">
        АКТ СПИСАНИЯ
      </span>
    </h1>
    <div v-if="!loading" class="card lh-1">
      <div class="card-body">
        <div class="row row-cols-2">
          <div class="col text-muted">Дата</div>
          <div class="col text-muted">Номер</div>
          <div class="col">
            <v-date-picker v-model="doc.date" mode="dateTime" is24hr utc>
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="
                    px-0
                    fs-5
                    border
                    rounded
                    focus:outline-none focus:border-blue-300
                  "
                  :value="inputValue"
                  v-on="inputEvents"
                  :disabled="!newDoc || list || isManager || doc.cancel"
                  style="width: 100%; padding-top: 2px; padding-bottom: 2px"
                />
              </template>
            </v-date-picker>
          </div>
          <div class="col">
            <input
              v-if="!list"
              class="form-control px-0 py-0 fs-5"
              :value="`${doc.prefix}-${doc.number}`"
              :disabled="true"
              type="text"
            />
            <span v-if="list" class="fs-5">{{ `${doc.prefix}-${doc.number}` }}</span>
          </div>
        </div>

        <div v-if="(isAdmin || isManager) && !doc.writeOff" class="row row-cols-2 pt-2">
          <div class="col px-0">
            <input
              type="radio"
              :value="true"
              v-model="doc.fixPrice"
              :disabled="doc._id || doc.cancel || isManager"
              class="btn-check"
              :name="`fix-price-${doc._id}`"
              :id="`fix-price-true-${doc._id}`"
              autocomplete="off"
              @change="
                () => {
                  // clearDeliverer();
                  // initFixPrice();
                }
              "
            />
            <label
              class="btn btn-outline-warning berry fs-5 text-dark"
              :for="`fix-price-true-${doc._id}`"
              >ФиксПрайс</label
            >
          </div>

          <div class="col px-0">
            <input
              type="radio"
              :value="false"
              v-model="doc.fixPrice"
              :disabled="doc._id || doc.cancel || isManager"
              class="btn-check"
              :name="`fix-price-${doc._id}`"
              :id="`fix-price-false-${doc._id}`"
              autocomplete="off"
            />
            <label
              class="btn btn-outline-warning berry fs-5 text-dark"
              :for="`fix-price-false-${doc._id}`"
              >Расчетная цена</label
            >
          </div>
        </div>

        <div v-if="isAdmin && doc.fixPrice" class="row row-cols-2 pt-2">
          <div class="col px-0">
            <input
              type="radio"
              :value="true"
              v-model="doc.fixPriceReceiver"
              :disabled="list || doc.cancel || isManager"
              class="btn-check"
              :name="`fix-price-receiver-${doc._id}`"
              :id="`fix-price-receiver-true-${doc._id}`"
              autocomplete="off"
              @change="
                () => {
                  // clearDeliverer();
                  // initFixPrice();
                }
              "
            />
            <label
              class="btn btn-outline-warning berry fs-5 text-dark"
              :for="`fix-price-receiver-true-${doc._id}`"
              >Оптовик</label
            >
          </div>

          <div class="col px-0">
            <input
              type="radio"
              :value="false"
              v-model="doc.fixPriceReceiver"
              :disabled="list || doc.cancel || isManager"
              class="btn-check"
              :name="`fix-price-receiver-${doc._id}`"
              :id="`fix-price-receiver-false-${doc._id}`"
              autocomplete="off"
            />
            <label
              class="btn btn-outline-warning berry fs-5 text-dark"
              :for="`fix-price-receiver-false-${doc._id}`"
              >Физлицо</label
            >
          </div>
        </div>

        <div v-if="berries.length > 0 && !list" class="row row-cols-2 pt-2">
          <div v-for="berry in berries" :key="berry._id" class="col px-0">
            <input
              type="radio"
              class="btn-check"
              :name="`berries-${doc._id}`"
              :disabled="list || !newDoc || isManager || doc.cancel"
              :value="berry._id"
              v-model="doc.tableUnit[0].berry"
              :id="`berry-${berry._id}`"
              autocomplete="off"
              @change="getPrice()"
            />
            <label class="btn btn-outline-primary berry fs-5" :for="`berry-${berry._id}`">{{
              berry.label
            }}</label>
          </div>
        </div>

        <div v-if="list" class="row row-cols-1 pt-2">
          <div class="col text-center">
            <span class="fs-1"
              ><strong>{{ berries[0].label }}</strong></span
            >
          </div>
        </div>

        <div class="row pt-2" :class="{ 'row-cols-2': !doc.fixPrice, 'row-cols-1': doc.fixPrice }">
          <div class="col text-muted text-center">Вес, кг</div>
          <div class="col text-muted text-center" v-if="!doc.fixPrice">
            Доступный вес, кг
          </div>
          <div class="col pt-1 text-center">
            <input
              v-if="!list"
              class="form-control px-0 input-price summ text-center"
              v-model="doc.tableUnit[0].weight"
              type="number"
              :disabled="!newDoc || isManager || doc.cancel"
              @input="getPrice()"
            />
            <span v-if="list" class="fs-1 lh-1 text-center">{{
              doc.tableUnit[0].weight.toFixed(2)
            }}</span>
          </div>

          <div class="col pt-1 text-center" v-if="!doc.fixPrice">
            <input
              class="form-control px-0 input-price summ text-center"
              v-model="doc.weightDry"
              type="number"
              disabled
            />
          </div>
        </div>

        <div class="row pt-2" :class="{ 'row-cols-2': !doc.fixPrice, 'row-cols-1': doc.fixPrice }">
          <div class="col text-muted text-center">Цена, у.е.</div>
          <div class="col text-muted" v-if="!doc.fixPrice">Цена новая, у.е.</div>
          <div class="col pt-1 text-center">
            <input
              v-if="!list"
              class="form-control px-0 input-price summ text-center"
              v-model="doc.tableUnit[0].price"
              type="number"
              :disabled="!doc.fixPrice || isManager || doc.cancel"
            />
            <span v-if="list" class="fs-1 lh-1 text-center">{{ doc.tableUnit[0].price }}</span>
          </div>

          <div class="col pt-1 text-center" v-if="!doc.fixPrice">
            <input
              class="form-control px-0 input-price summ text-center"
              :value="doc.newPrice"
              type="number"
              disabled
            />
          </div>
        </div>

        <div
          v-if="!doc.fixPrice"
          class="row pt-2"
          :class="{ 'row-cols-2': !doc.fixPrice, 'row-cols-1': doc.fixPrice }"
        >
          <div class="col text-muted text-center">Вес нераспред, кг</div>
          <div class="col text-muted">Цена нераспред, у.е.</div>
          <div class="col pt-1 text-center">
            <input
              v-if="!list"
              class="form-control px-0 input-price summ text-center"
              v-model="doc.weightManual"
              type="number"
              :disabled="isManager || doc.cancel"
            />
            <span v-if="list" class="fs-1 lh-1 text-center">{{ doc.weightManual.toFixed(2) }}</span>
          </div>

          <div class="col pt-1 text-center">
            <input
              v-if="!list"
              class="form-control px-0 input-price summ text-center"
              v-model="doc.priceManual"
              type="number"
              :disabled="isManager || doc.cancel"
            />
            <span v-if="list" class="fs-1 lh-1 text-center">{{ doc.priceManual }}</span>
          </div>
        </div>

        <div
          v-if="(doc.fixPrice && doc.fixPriceReceiver) || !doc.fixPrice"
          class="row row-cols-1 pt-2"
        >
          <div class="col text-muted"><small>Оптовик</small></div>
          <div class="col">
            <Multiselect
              v-model="doc.company"
              :options="usersWholesaler"
              :loading="false"
              :internal-search="false"
              valueProp="_id"
              trackBy="fullname"
              label="fullname"
              :filterResults="true"
              :minChars="2"
              :resolveOnLoad="true"
              :searchable="true"
              class="deliverer"
              style="min-height: 3rem"
              noOptionsText="Не найден"
              required
              @select="getPrice()"
              :disabled="list || isManager || doc.cancel"
            >
            </Multiselect>
          </div>
        </div>

        <div v-if="doc.fixPrice && !doc.fixPriceReceiver" class="row row-cols-1 pt-2">
          <div class="col text-muted"><small>Физлицо</small></div>
          <div class="col">
            <Multiselect
              v-model="doc.company"
              :options="usersDeliverer"
              :loading="false"
              :internal-search="false"
              valueProp="_id"
              trackBy="fullname"
              label="fullname"
              :filterResults="true"
              :minChars="2"
              :resolveOnLoad="true"
              :searchable="true"
              class="deliverer"
              style="min-height: 3rem"
              noOptionsText="Не найден"
              required
              @select="getPrice()"
              :disabled="list || isManager || doc.cancel"
            >
            </Multiselect>
          </div>
        </div>

        <div class="row row-cols-1 mt-2">
          <div class="col text-muted"><small>Комментарий</small></div>
          <div class="col ">
            <input class="form-control p-1 fs-4" v-model="doc.comment" type="text" />
          </div>
        </div>

        <div v-if="!doc.fixPrice && doc.detailsTotal" class="accordion-item mt-2">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTotal"
              aria-expanded="false"
              aria-controls="collapseTotal"
            >
              ИТОГО
            </button>
          </h2>
          <div
            id="collapseTotal"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="row row-cols-2 pt-2">
                <div class="col text-muted">
                  <small>Cухой, у.е./кг</small>
                </div>
                <div class="col text-muted">
                  <small>Усушка, у.е./кг</small>
                </div>
                <div class="col text-muted">
                  <small>{{
                    (doc.detailsTotal.sumDry / doc.detailsTotal.weightDry).toFixed(2)
                  }}</small>
                </div>
                <div class="col text-muted">
                  <small>{{
                    (doc.detailsTotal.sumShrink / doc.detailsTotal.weightDry).toFixed(2)
                  }}</small>
                </div>
              </div>
              <div v-if="!doc.writeOff" class="row row-cols-3 pt-2">
                <div class="col text-muted">
                  <small>Бонус, у.е./кг</small>
                </div>
                <div class="col text-muted">
                  <small>Логистика, у.е./кг</small>
                </div>
                <div class="col text-muted">
                  <small>Доп затраты, у.е./кг</small>
                </div>
                <div class="col text-muted">
                  <small>{{
                    (doc.detailsTotal.sumBonus / doc.detailsTotal.weightDry).toFixed(2)
                  }}</small>
                </div>
                <div class="col text-muted">
                  <small>{{
                    (doc.detailsTotal.sumLogist / doc.detailsTotal.weightDry).toFixed(2)
                  }}</small>
                </div>
                <div class="col text-muted">
                  <small>{{
                    (doc.detailsTotal.sumCost / doc.detailsTotal.weightDry).toFixed(2)
                  }}</small>
                </div>
              </div>

              <div v-if="false" class="row row-cols-1 pt-2">
                <div class="col text-muted">
                  <small
                    >ВСЕГО
                    {{
                      (
                        doc.detailsTotal.sumDry +
                        doc.detailsTotal.sumShrink +
                        doc.detailsTotal.sumBonus +
                        doc.detailsTotal.sumLogist +
                        doc.detailsTotal.sumCost
                      ).toFixed(2)
                    }}
                    у.е. / {{ doc.detailsTotal.weightDry.toFixed(2) }} кг =
                    {{ doc.tableUnit[0].price }}</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!doc.fixPrice" class="accordion-item mt-2">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              РАСЧЕТ ЦЕНЫ
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="row row-cols-1 pt-2">
                <div class="row" v-for="(detail, index) in doc.details" :key="index">
                  <div class="row text-muted mt-2">
                    <router-link
                      :to="{
                        name: 'acceptance',
                        params: { id: detail.acceptanceId }
                      }"
                    >
                      <small>{{ detail.acceptanceLabel }}</small>
                    </router-link>
                  </div>
                  <div class="row row-cols-2">
                    <div class="col text-muted">
                      <small>Принимаемый для расчета вес, кг</small>
                    </div>
                    <div class="col text-muted">
                      <small>Принимаемая для расчета сумма, руб</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightTotalAccept.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumTotalAccept.toFixed(2) }}</small>
                    </div>
                  </div>

                  <div
                    class="row mt-3"
                    :class="{ 'row-cols-4': !doc.writeOff, 'row-cols-1': doc.writeOff }"
                  >
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>Бонус, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>Логистика, у.е.</small>
                    </div>
                    <div class="col text-muted">
                      <small>Общая усушка, %</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>Доп затраты, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.rateTotal.bonus }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.rateTotal.logist }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.rateTotal.shrink }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.rateTotal.cost }}</small>
                    </div>
                  </div>
                  <div class="row row-cols-3 mt-3">
                    <div class="col text-muted mt-2"><small>Всего</small></div>
                    <div class="col text-muted mt-2">
                      <small>Закрыто</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Принято</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Вес сухой, кг</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Вес сухой, кг</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Вес сухой, кг</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightDry.total.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightDry.closed.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightDry.accept.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Усушка, кг</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Усушка, кг</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Усушка, кг</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightShrink.total.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightShrink.closed.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.weightShrink.accept.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма всего, у.е.</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма всего, у.е.</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма всего, у.е.</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumDry.total.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumDry.closed.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumDry.accept.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма усушка, у.е.</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма усушка, у.е.</small>
                    </div>
                    <div class="col text-muted mt-2">
                      <small>Сумма усушка, у.е.</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumShrink.total.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumShrink.closed.toFixed(2) }}</small>
                    </div>
                    <div class="col text-muted">
                      <small>{{ detail.result.sumShrink.accept.toFixed(2) }}</small>
                    </div>

                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма логистика, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма логистика, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма логистика, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumLogist.total.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumLogist.closed.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumLogist.accept.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма бонус, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма бонус, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма бонус, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumBonus.total.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumBonus.closed.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumBonus.accept.toFixed(2) }}</small>
                    </div>

                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма доп затраты, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма доп затраты, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted mt-2">
                      <small>Сумма доп затраты, у.е.</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumCost.total.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumCost.closed.toFixed(2) }}</small>
                    </div>
                    <div v-if="!doc.writeOff" class="col text-muted">
                      <small>{{ detail.result.sumCost.accept.toFixed(2) }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-cols-1 pt-2">
          <div class="col">
            Корректировка
            <input
              class="form-check-input"
              type="checkbox"
              v-model="doc.manualEdit"
              :disabled="!newDoc || doc.cancel"
            />
          </div>
          <div class="col" v-if="doc.manualEdit">
            <div class="row">
              <div class="col">
                Усушка, %
              </div>
              <div class="col">
                <input
                  class="form-control px-0 text-center"
                  v-model="doc.manualEditShrink"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
            <div class="row mt-1">
              <button
                id="manual-recalc-doc"
                type="button"
                class="btn btn-warning btn-lg w-100"
                @click="recalcDoc"
              >
                ПЕРЕСЧИТАТЬ
                <div v-if="loadingRecalc" class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div v-if="!list && !isManager" class="row row-cols-1 pt-2">
          <div class="col px-0">
            <button
              id="save-doc"
              type="button"
              class="btn btn-success btn-lg w-100"
              @click="saveDoc"
              :disabled="!newDoc || doc.cancel"
            >
              ЗАПИСАТЬ
              <div v-if="loadingSave" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>

            <button
              v-if="doc.cancel || isAdmin"
              id="save-doc"
              type="button"
              class="btn btn-danger btn-lg w-100 mt-2"
              @click="cancelDoc()"
              :disabled="doc.cancel"
            >
              <span v-if="doc.cancel"> ОТМЕНЕН </span>
              <span v-if="!doc.cancel"> ОТМЕНИТЬ </span>

              <div v-if="loadingCancel" class="spinner-border" role="status">
                <span class="sr-only"></span>
              </div>
            </button>

            <router-link
              v-if="!list"
              class="btn btn-lg btn-secondary w-100 text-center mt-2"
              type="button"
              tag="button"
              :to="doc.writeOff ? { name: 'writeoffs' } : { name: 'transfers' }"
            >
              НАЗАД
            </router-link>
          </div>
        </div>

        <div v-if="!list" id="modal-msg" class="modal justify-content-center" tabindex="-1">
          <div class="vertical-alignment-helper">
            <div class="modal-dialog vertical-align-center">
              <div class="modal-content">
                <div class="modal-body berry">
                  <ul class="list-group">
                    <li v-for="(msg, index) in modalMessages" :key="index" class="list-group-item">
                      {{ msg }}
                    </li>
                  </ul>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Закрыть
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";
import Multiselect from "@vueform/multiselect";
import * as bootstrap from "bootstrap";

export default {
  name: "Transfer",

  components: {
    Multiselect
  },

  props: {
    id: { default: "new" },
    list: { default: false },
    writeOff: { default: false }
  },

  setup(props) {
    const store = useStore();
    const router = useRouter();
    useCommonMixin();
    const {
      jwtAccessValid,
      userProfile,
      isReciever,
      isAdmin,
      isManager,
      asyncForEach,
      isManagerFB,
    } = useCommonMixin();
    const doc = ref({});
    const loading = ref(true);
    const loadingSave = ref(false);
    const loadingCancel = ref(false);
    const modalMessages = ref([]);
    const master = ref({});
    const users = ref([]);
    const usersDeliverer = ref([]);
    const roles = ref([]);

    const init = async () => {
      Date.prototype.addHours = function(h) {
        this.setTime(this.getTime() + h * 60 * 60 * 1000);
        return this;
      };

      let response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
      });

      response = await store.dispatch("FETCHuser", "deliverer");
      usersDeliverer.value = response.status ? response.data : [];
      asyncForEach(usersDeliverer.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = `${user.passport.lastName} ${user.passport.firstName} ${user.passport.middleName}`;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];

      // console.log('roles', roles.value);

      // await store.dispatch("FETCHuserProfile", { userId: null, phone: null });
      //await store.dispatch("FETCHberry");
      if (props.id == "new") {
        doc.value = {
          _id: null,
          date: new Date(),
          number: "",
          prefix: "",
          company: {
            // _id: userProfile.value._id,
            // receiver: {
            //   fullname: userProfile.value.receiver.fullname,
            //   master: userProfile.value.receiver.master,
            // },
          },
          fixPrice: false,
          fixPriceReceiver: true,
          writeOff: JSON.parse(props.writeOff),
          tableUnit: [
            {
              berry: null,
              weight: ""
            }
          ]
        };

        console.log("doc", doc.value.company);
      } else {
        let response = await store.dispatch("FETCHtransfer", props.id);
        if (response.status) doc.value = response.data;
        doc.value.date = new Date(doc.value.date);
        doc.value.weightManual = doc.value.weightManual ? doc.value.weightManual.toFixed(2) : 0;
        doc.value.tableUnit[0].weight = doc.value.tableUnit[0].weight.toFixed(2);
      }

      // master.value = await store.dispatch("FETCHuserProfile", {
      //   userId: doc.value.company.receiver.master,
      //   phone: null,
      // });

      console.log("doc", doc.value.company);
      loading.value = false;
    };

    const saveDoc = async () => {
      loadingSave.value = true;
      doc.value.tableUnit[0].weight =
        doc.value.tableUnit[0].weight > doc.value.weightDry
          ? doc.value.weightDry
          : doc.value.tableUnit[0].weight;
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = [];
      if (!doc.value.tableUnit[0].berry) modalMessages.value.push("Выберите ягоду");
      //if (!doc.value.tableUnit[0].weight) modalMessages.value.push("Заполните вес");

      if (modalMessages.value.length <= 0) {
        let response = await store.dispatch("POSTtransfer", doc.value);
        if (response.status) {
          modalMessages.value = props.writeOff
            ? ["Акт списания сохранен"]
            : ["Акт передачи сохранен"];
          doc.value._id = response.data._id;
          doc.value.number = response.data.number;
          router.push({ name: "transfer", params: { id: "new" } });
          init();
          // router.push({ name: "transfer", params: { id: response.data._id } });
        } else {
          modalMessages.value = [response.data.data.message];
        }
      }
      myModal.show();
      loadingSave.value = false;
    };

    const berries = computed(() => {
      let berry;
      if (props.list) {
        let berryIndex = store.getters.berry.findIndex(
          item => item._id == doc.value.tableUnit[0].berry
        );
        berry = berryIndex >= 0 ? [store.getters.berry[berryIndex]] : [{ label: "", _id: "" }];
      } else {
        berry = store.getters.berry;
      }
      return berry;
    });

    const newDoc = computed(() => {
      return doc.value._id ? true : true;
    });

    const getPrice = async () => {
      if (!doc.value.fixPrice) {
        console.log("getPrice");
        let response = await store.dispatch("FETCHtransferPrice", {
          weight: doc.value.tableUnit[0].weight,
          berry: doc.value.tableUnit[0].berry,
          receiverId: doc.value.company,
          transferId: doc.value._id,
          docType: doc.value.writeOff ? "writeOff" : "transfer"
        });
        if (response.status) {
          doc.value.details = response.data.details;
          doc.value.detailsTotal = response.data.detailsTotal;
          doc.value.weightDry = response.data.weightDry;
          doc.value.newPrice = response.data.price;
          doc.value.tableUnit[0].price = newDoc.value
            ? response.data.price
            : doc.value.tableUnit[0].price;
          doc.value.weightManual = doc.value.tableUnit[0].weight - doc.value.weightDry;
        }
      }
    };

    const usersWholesaler = computed(() => {
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      let receiverRole = roles.value.find(item => item.name == "receiver");
      let result = users.value.filter(
        item => item.role == wholesalerRole._id || item.role == receiverRole._id
      );
      console.log("result", result);
      return result;
    });

    const cancelDoc = async () => {
      loadingSave.value = true;
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = [];

      let response = await store.dispatch("CANCELtransfer", doc.value);
      if (response.status) {
        modalMessages.value = ["Акт передачи отменен"];
        doc.value = response.data;
        doc.value.date = new Date(doc.value.date);
        router.push({ name: "transfer", params: { id: response.data._id } });
      } else {
        modalMessages.value = [response.data.data.message];
      }
      myModal.show();
      loadingSave.value = false;
    };

    const loadingRecalc = ref(false)
    const recalcDoc = async () => {
      loadingRecalc.value = true;
      let myModal = new bootstrap.Modal(document.getElementById("modal-msg"), {});
      modalMessages.value = [];

      let response = await store.dispatch("RECALCtransfer", doc.value);
      if (response.status) {
        modalMessages.value = ["Акт передачи пересчитан"];
        doc.value = response.data;
        doc.value.date = new Date(doc.value.date);
        router.push({ name: "transfer", params: { id: response.data._id } });
      } else {
        modalMessages.value = [response.data.data.message];
      }
      myModal.show();
      loadingRecalc.value = false;
    };

    onBeforeMount(init);

    return {
      jwtAccessValid,
      isReciever,
      doc,
      berries,
      saveDoc,
      loading,
      modalMessages,
      userProfile,
      master,
      isAdmin,
      loadingSave,
      newDoc,
      getPrice,
      usersWholesaler,
      usersDeliverer,
      isManager,
      loadingCancel,
      cancelDoc,
      loadingRecalc,
      recalcDoc,
      isManagerFB,
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style></style>
